export class AttemptLimitExceededError extends Error {
	constructor() {
		super('Attempt limit has been exceeded');
		this.name = 'AttemptLimitExceededError';
	}
}
